import styled from '@emotion/styled';
import { Modal } from '@ui-components/neo.tax';

export const StyledModal = styled(Modal)({
  minHeight: 500,
  padding: 0,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});
